////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Transition } from 'react-transition-group'
import { isEmpty } from 'lodash'
///////COMPONENTS///////
import { toastSuccessActionCreators } from '../../store/actions'
/////////ASSETS/////////
import Close from '../../assets/icones/toast/close-toast.svg'
import ValidateIcon from '../../assets/icones/toast/check.svg'

/////////STYLED/////////
const Wrapper = styled.div`
	width: 100vw;
	heignt: 150px;
	top: ${({ transitionstate }) => {
		switch (transitionstate) {
			case 'entering':
				return '-150px'
			case 'entered':
				return '0px'
			case 'exiting':
				return '-150px'
			case 'exited':
				return '0px'
			default:
				return '-150px'
		}
	}};
	position: fixed;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 1s;
	z-index: 50;
`
const TosatWrapper = styled.div`
	height: 62px;
	width: 560px;
	background-color: #dbf5d7;
	border-radius: 0 0 5px 5px;
	border: 1px solid #cbf2c2;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
`
const ValidateIconWrapper = styled.img`
	height: 18px;
	width: 25px;
`
const SuccessMessageWrapper = styled.span`
	font-size: ${(props) => props.theme.font.fxs};
	color: ${(props) => props.theme.colors.toastText};
	text-align: left;
`
const CloseToast = styled.img`
	height: 24px;
	width: 24px;
	cursor: pointer;
`
/////////STYLED/////////

const ToastSuccess = () => {
	const [timer, setTimer] = useState(0)

	const { translations, toastSuccess } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			toastSuccess: state.toastSuccess,
		}),
		shallowEqual
	)

	const toastSuccessAction = bindActionCreators(toastSuccessActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleCloseTimer = () => {
		setTimer(0)
		toastSuccessAction.closeToast()
	}
	const clock = () => {
		return setTimeout(() => {
			handleCloseTimer()
		}, 4000)
	}

	const handleCloseToast = () => {
		setTimer(0)
		toastSuccessAction.closeToast()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (toastSuccess.show) {
			if (timer !== 0) {
				clearTimeout(timer)
				handleCloseTimer()
				setTimeout(() => {
					toastSuccessAction.openNext()
				}, 500)
				return
			}
			setTimer(clock())
		}
	}, [toastSuccess])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Transition
			in={toastSuccess.show}
			timeout={{
				appear: 0,
				enter: 0,
				exit: 3000,
			}}
			mountOnEnter
			unmountOnExit
		>
			{(state) => (
				<Wrapper transitionstate={state}>
					<TosatWrapper>
						<ValidateIconWrapper src={ValidateIcon} />

						<SuccessMessageWrapper>
							{!isEmpty(translations[toastSuccess.successMsgParams])
								? translations[toastSuccess.successMsgParams]
								: translations[toastSuccess.tamponClose]}
						</SuccessMessageWrapper>
						<CloseToast src={Close} onClick={handleCloseToast} />
					</TosatWrapper>
				</Wrapper>
			)}
		</Transition>
	)
}

export default ToastSuccess
